export function isTouch() {
    return 'ontouchstart' in window;
}